import { AiFillMessage } from "react-icons/ai";
import Link from "next/link";
import { uniformClasses } from "@std/legacy_componentry/Root/NavPartials/NavSocials";
import { Search, SocialLink } from "./Elements";
import { FaInstagram, FaTwitch, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Image from "next/image";
import { BrandIconLink } from "../Branding";

export const SocialLinks = () => (
    <>
        <SocialLink label="YouTube" href="https://youtube.com/kooleyy">
            <FaYoutube />
        </SocialLink>
        <SocialLink label="Twitch" href="https://twitch.tv/kooleyy">
            <FaTwitch />
        </SocialLink>
        <SocialLink label="Twitter page" href="https://twitter.com/Kooleyy__">
            <FaXTwitter />
        </SocialLink>
        <SocialLink label="Instagram page" href="https://www.instagram.com/Kooleyy">
            <FaInstagram />
        </SocialLink>
    </>
);

export const Contacts = () => (
    <>
        <Link href="mailto:business@kooleyy.com" target="_blank" rel="noreferrer" className="hidden xl:flex flex-row font-BreezeHeader gap-x-2 text-sm px-6 py-2 bg-cyan-300 hover:bg-cyan-400 active:shadow-lg transition duration-150 ease-in-out text-sp text-black rounded-full text-center">
            Contact
        </Link>
        <div className="hidden md:flex absolute inset-y-0 right-0 items-center pr-10 sm:pr-6 sm:static sm:inset-auto sm:ml-6 gap-x-6 text-xl lg:text-2xl">
            <SocialLinks />
            <Link href="mailto:business@kooleyy.com" target="_blank" className="xl:hidden" rel="noreferrer">
                <AiFillMessage className={`w-8 text-cyan-400 hover:text-cyan-500 transition ease-in-out duration-200`} />
            </Link>
        </div>
    </>
);

export const Brand = () => (
    <div className="flex flex-row gap-x-3 md:gap-x-4 justify-center content-center">
        <div className="flex flex-row gap-x-3 md:gap-x-4 justify-center content-center" id="PrimaryNav-Top-NameInfo">
            <BrandIconLink />
            <Link href="/" className="flex flex-col justify-center content-center">
                <h1 className="text-lg">Kooleyy</h1>
                <h2 className="hidden sm:block text-sm text-gray-300 whitespace-pre">Video Editor<b className="font-bold hidden md:inline-block"> · Content Manager</b></h2>
            </Link>
        </div>
    </div>
);

export const HeaderBar = () => (
    <div className={`md:bg-slate-900 drop-shadow-xl md:drop-shadow-none sm:px-6 py-6 md:pb-4 relative hidden md:flex flex-col gap-y-4 md:flex-row items-center justify-between`} id="PrimaryNav-Top">
        <Brand />
        <Search />
        <Contacts />
    </div>
);